import 'normalize.css';
import '@/assets/styles/global.scss';
import Vue from 'vue';
import router from '@/router/';
import './registerServiceWorker';
import { apolloProvider } from '@/utils/vue-apollo';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import './optionMergeStrategies';
import '@/components/UI';
import '@/layouts';
import PortalVue from 'portal-vue';
import VTooltip from 'v-tooltip';
import App from '@/App.vue';
import SomethingWentWrong from '@/components/SomethingWentWrong.vue';
import i18n from './i18n';
import './filters';
import './directives';
import VueApexCharts from 'vue-apexcharts';
import VueStrictDayjs from '@/utils/strict-date/strict-plugin';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import js404Handler from './utils/js-404-handler';

Bugsnag.start({
  apiKey: 'edc034ab8bee3e60ee5494ba0282dfef',
  plugins: [ new BugsnagPluginVue(Vue) ],
  onError: function(event) {
    if (event.originalError.name === 'NavigationDuplicated') return false;
    return true;
  },
  enabledReleaseStages: [ 'production', 'staging' ],
  maxBreadcrumbs: 60,
});

Vue.use(VTooltip, {
  defaultBoundariesElement: 'body',
  popover: {
    defaultHandleResize: false, // handleResize causes forced reflows when mounting
  },
});
Vue.use(PortalVue);
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('Apexchart', VueApexCharts);

Vue.use(VueStrictDayjs);

Vue.component('something-went-wrong', SomethingWentWrong);

Vue.config.productionTip = false;

Vue.config.keyCodes = {
  decimal: 110,
};

Vue.mixin({
  methods: {
    t_attr: function(model: string, attr: string) {
      return this.$t(`GQL.Model.${model}.Attribute.${attr}`);
    },
  },
});

new Vue({
  router,
  apolloProvider,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', function(event) {
    if (event.data.action === '404jsHappened') {
      js404Handler.handle(router);
    }
  });
}
